import { EventEmitter, Injectable } from '@angular/core';
import { io, Socket, SocketOptions, ManagerOptions } from 'socket.io-client';
// import { NetworkManagementService } from './network-management.service';
import { ConfigurationService } from './configuration.service';
// import { AppState } from '../classes/appstate.class';
import { Configurations } from './configurations.class';
import { ApiRequestsService } from './api-requests.service';

export type EventHandlers = { [evt: string]: (params: any) => void }

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private webSocket: Socket | null = null;
  private connectIfPossible = false;
  private isConnected = false;
  public ITRJsonEvent:EventEmitter<any> = new EventEmitter();
  public socketEventHandlers: EventHandlers = {
    connect: () => {
      console.log('Socket is created');
      this.isConnected = true;
    },
    connect_error: (e: any) => {
      console.log(`Error in Socket ${JSON.stringify(e)}`);
      // this.closeConnection();
      this.isConnected = false;

    },
    disconnect: () => {
      console.log('Socket is disconnect');
      this.closeConnection();
      this.isConnected = false;
    },

    ITR_JSON: (data:any) => {
      this.ITRJsonEvent.emit(data);
    }
  };

  constructor(
    private config: ConfigurationService, private Api: ApiRequestsService, private Configration:ConfigurationService
    // private network: NetworkManagementService
  ) { }

  createWebSocketConnection = () => {

    const token = this.Api.Token;
    const sockOptions: SocketOptions | ManagerOptions = {
      query: {},
      auth: { token, transports: ['websocket'] },//, 'polling', 'flashsocket'
      autoConnect: false,
    };
    console.warn('createSocketAndInitiateCommunication token');
    console.log('token', token);

    this.webSocket = io(this.Configration.getBaseUrl(), sockOptions);
    console.log(this.Configration.getBaseUrl());

    for (let evh in this.socketEventHandlers) {
      console.log('socketEventHandlers', evh);

      this.webSocket.on(evh, this.socketEventHandlers[evh]);
    }
    this.webSocket.connect();
  };

  closeConnection = () => {
    if (this.webSocket) {
      this.webSocket.close();
      this.webSocket = null;
    }
  };

  sendMessage = (topic: string, data: any) => {
    if (this.webSocket) {
      this.webSocket.emit(topic, data);
    }
    
  }

  setEventHandlers = (
    handlerFunctions: EventHandlers,
    clearPreviousHandlers = false
  ) => {
    
    for (let evh of Object.keys(handlerFunctions)) {
      if (typeof handlerFunctions[evh] !== 'function') {
        throw `Invalid or incorrect event handlers`;
      }
    }
    if (clearPreviousHandlers) {
      this.socketEventHandlers = handlerFunctions;
    } else {
      this.socketEventHandlers = {
        ...this.socketEventHandlers,
        ...handlerFunctions,
      };
    }
  };

  public get IsConnected() {
    return this.isConnected;
  }

  public get ConnectIfPossible() {
    return this.connectIfPossible;
  }
  public set ConnectIfPossible(val: boolean) {
    this.connectIfPossible = val;
  }
}
